import React from 'react';
import { BatteryLow, Waves, Cloud } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const symptoms = [{
    icon: BatteryLow,
    title: 'Fatiga Crónica',
    desc: 'Despertar agotada a pesar de dormir 8 horas. Depender del café solo para sobrevivir el bajón de la tarde.'
  }, {
    icon: Waves,
    title: 'Hinchazón Inexplicable',
    desc: "Sentirte incómoda en tu propia ropa para las 3 PM, sin importar qué tan 'limpio' hayas comido."
  }, {
    icon: Cloud,
    title: 'Niebla Mental',
    desc: 'Costarte concentrarte, olvidar palabras simples y sentirte desconectada de tu versión más lúcida.'
  }];
  return <section className="py-20 md:py-32 bg-cream" data-id="element-134">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-135">
        <div className="text-center mb-12 md:mb-20" data-id="element-136">
          <FadeIn data-id="element-137">
            <span className="uppercase tracking-[0.2em] text-xs text-ink-light mb-4 block" data-id="element-138">
              La Realidad
            </span>
            <h2 className="font-serif text-3xl md:text-5xl text-ink" data-id="element-139">
              ¿Te suena <em className="italic" data-id="element-140">familiar?</em>
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8" data-id="element-141">
          {symptoms.map((symptom, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-142">
              <div className="group bg-white p-7 md:p-10 h-full border border-ink/5 shadow-soft hover:shadow-soft-lg transition-all duration-500 hover:-translate-y-1" data-id="element-143">
                <div className="w-12 h-12 bg-sage rounded-full flex items-center justify-center mb-8 text-ink group-hover:scale-110 transition-transform duration-500" data-id="element-144">
                  <symptom.icon strokeWidth={1.5} className="w-6 h-6" data-id="element-145" />
                </div>
                <h3 className="font-serif text-2xl mb-4 text-ink" data-id="element-146">
                  {symptom.title}
                </h3>
                <p className="text-ink-light font-light leading-relaxed" data-id="element-147">
                  {symptom.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}